/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		marginTop: 24,
		borderWidth: 1,
		borderColor: borderColor,
	},

	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		height: 24,
		alignItems: 'center',
	},

	headerCell: {
		fontSize: 10,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		padding: 4,
	},

	
	id: { width: '6%', textAlign: 'center' },
	name: { width: '14%', textAlign: 'left' },
	allocation: { width: '10%', textAlign: 'center' },
	incoming: { width: '14%', textAlign: 'left' },
	outgoing: { width: '14%', textAlign: 'left' },
	chainage: { width: '10%', textAlign: 'center' },
	remarks: { width: '16%', textAlign: 'left' },
	shift: { width: '16%', textAlign: 'center', borderRightWidth: 0 }
});

const paginate = (array, perPage) => {
	const pages = [];
	for (let i = 0; i < array.length; i += perPage)
		pages.push(array.slice(i, i + perPage));
	return pages;
};

const InvoiceItemsTable = (props) => {

	const itemsPerPage = 10;
	const pages = paginate(props.invoice, itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>

					{/* Insert break ONLY for pages after the first */}
					{pageIndex > 1 && <View break />}

					{/* Page Section */}
					<View wrap={true}>
						{/* Table Header */}
						<View style={styles.container}>
							<Text style={[styles.headerCell, styles.id]}>Id</Text>
							<Text style={[styles.headerCell, styles.name]}>Name</Text>
							<Text style={[styles.headerCell, styles.allocation]}>Allocation</Text>
							<Text style={[styles.headerCell, styles.incoming]}>Incoming</Text>
							<Text style={[styles.headerCell, styles.outgoing]}>Outgoing</Text>
							<Text style={[styles.headerCell, styles.chainage]}>Chainage</Text>
							<Text style={[styles.headerCell, styles.remarks]}>Remarks</Text>
							<Text style={[styles.headerCell, styles.shift]}>Shift Time</Text>
						</View>

						{/* Table Rows */}
						<InvoiceTableRow data={pageData} />
					</View>

				</React.Fragment>
			))}
		</>

	);
};

export default InvoiceItemsTable;
